import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import { ThemeProvider } from "./shared/components/ThemeProvider.jsx";
import { ConfirmProvider } from "./shared/components/ConfirmDialog.jsx";
import { captureAuthRedirect } from "./shared/utils/authRedirectHash.js";
import "./styles.css";

// BEFORE React mounts. Supabase reports the outcome of an email link in the URL
// fragment, and RequireAuth's redirect to /login drops it — so by the time any
// screen renders, the reason is gone and the user sees a silent dead end
// (backlog item 63). Capture it here, then screens can show it.
captureAuthRedirect();

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider>
      <ConfirmProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ConfirmProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
